import { render, staticRenderFns } from "./UploadDrop.vue?vue&type=template&id=12f16bc7"
import script from "./UploadDrop.vue?vue&type=script&lang=js"
export * from "./UploadDrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports